import { createFileRoute } from '@tanstack/react-router'
import { ShieldOff } from 'lucide-react'
import { EmptyState } from '@/components/data/EmptyState'
import { MlroCaseDetailView } from '@/components/mlro/MlroCaseDetailView'
import { useRoles } from '@/hooks/useRoles'

export const Route = createFileRoute('/mlro/cases/$id')({
    component: MlroCaseDetailPage,
})

function MlroCaseDetailPage() {
    const { id } = Route.useParams()
    const { hasAnyRole } = useRoles()

    if (!hasAnyRole('mlro')) {
        return (
            <EmptyState
                icon={ShieldOff}
                title="No access"
                description="The MLRO surfaces are restricted to operators with the MLRO role."
            />
        )
    }

    return <MlroCaseDetailView caseId={id} />
}
